import DashboardSection from './dashboardSection';
import Orders from './ordersSection';
import PersonalInfo from './personalSection';
import CustomerAddressPanel from '../customerAddressPanel';
import styles from './dashboard.module.scss';

const Dashboard = ({
  locale,
  accountpagenavigation,
  addaddressformaccountpage,
  dashboardaccountpage,
  ordersaccountpage,
  orderdetailsaccountpage,
  secondorderdetailsaccountpage,
  personalinfoaccountpage,
  secondpersonalinfoaccountpage,
  thirdpersonalinfoaccountpage,
  addressbookaccountpage,
  secondaddressbookaccountpage,
  customer,
  navTracker,
  showDetails,
  toggleAddForm,
  toggleUpdateForm,
  setNavTracker,
  setShowDetails,
  setAddToggleForm,
  setUpdateToggleForm,
  order,
  setOrder,
  checkout,
  salonselector,
  registermessages,
  subscriptionsLink,
}) => (
  <div className={styles.container}>
    {navTracker === 'dashboard' && (
      <DashboardSection
        customer={customer}
        locale={locale}
        setNavTracker={setNavTracker}
        accountpagenavigation={accountpagenavigation}
        dashboardaccountpage={dashboardaccountpage}
        subscriptionsLink={subscriptionsLink}
      />
    )}
    {navTracker === 'orders' && (
      <Orders
        customer={customer}
        locale={locale}
        showDetails={showDetails}
        setShowDetails={setShowDetails}
        order={order}
        setOrder={setOrder}
        ordersaccountpage={ordersaccountpage}
        orderdetailsaccountpage={orderdetailsaccountpage}
        secondorderdetailsaccountpage={secondorderdetailsaccountpage}
      />
    )}
    {navTracker === 'personalInfo' && (
      <PersonalInfo
        accountpagenavigation={accountpagenavigation}
        customer={customer}
        locale={locale}
        personalinfoaccountpage={personalinfoaccountpage}
        secondpersonalinfoaccountpage={secondpersonalinfoaccountpage}
        thirdpersonalinfoaccountpage={thirdpersonalinfoaccountpage}
        checkout={checkout}
        salonselector={salonselector}
        registermessages={registermessages}
      />
    )}
    {navTracker === 'addressBook' && (
      <CustomerAddressPanel
        accountpagenavigation={accountpagenavigation}
        customer={customer}
        toggleAddForm={toggleAddForm}
        toggleUpdateForm={toggleUpdateForm}
        setAddToggleForm={setAddToggleForm}
        setUpdateToggleForm={setUpdateToggleForm}
        addressbookaccountpage={addressbookaccountpage}
        addaddressformaccountpage={addaddressformaccountpage}
        secondaddressbookaccountpage={secondaddressbookaccountpage}
      />
    )}
  </div>
);

export default Dashboard;
